"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateRange = void 0;
var react_1 = __importStar(require("react"));
var date_fns_1 = require("date-fns");
var mixpanel_events_1 = require("../../../constants/mixpanel-events");
var DateRangeComponent_1 = require("./DateRangeComponent");
var DateRangeComponentV2_1 = require("./DateRangeComponentV2");
var DateRangeMenu_1 = __importDefault(require("./DateRangeMenu"));
var dateRangePicker_constants_1 = require("./dateRangePicker.constants");
var DateRange = function (_a) {
    var _b, _c, _d, _e, _f;
    var onChange = _a.onChange, defaultValue = _a.defaultValue, className = _a.className, id = _a.id, eventCallback = _a.eventCallback, _g = _a.useV2, useV2 = _g === void 0 ? false : _g, _h = _a.menuWrapperClassName, menuWrapperClassName = _h === void 0 ? '' : _h, _j = _a.useMenuOnly, useMenuOnly = _j === void 0 ? false : _j, _k = _a.controlClassName, controlClassName = _k === void 0 ? '' : _k, _l = _a.disabled, disabled = _l === void 0 ? false : _l, customRangeOptions = _a.customRangeOptions, _m = _a.leadingIconClassname, leadingIconClassname = _m === void 0 ? '' : _m;
    var _o = react_1.useState((defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.category) ? defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.category : dateRangePicker_constants_1.DATE_FILTER_CATEGORIES.ALL_TIME), selectedCategory = _o[0], setSelectedCategory = _o[1];
    var _p = react_1.useState({
        start: (_b = defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.start) !== null && _b !== void 0 ? _b : new Date(),
        end: (_c = defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.end) !== null && _c !== void 0 ? _c : new Date(),
    }), finalDateRange = _p[0], setFinalDateRange = _p[1];
    var _q = react_1.useState({
        startDate: (_d = defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.start) !== null && _d !== void 0 ? _d : new Date(),
        endDate: (_e = defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.end) !== null && _e !== void 0 ? _e : new Date(),
        key: 'selection',
        showDateDisplay: false,
    }), range = _q[0], setRange = _q[1];
    var handleCategorySelect = function (value, updatedRange) {
        var typedValue = value === null || value === void 0 ? void 0 : value.value;
        var today = new Date();
        today.setHours(0, 0, 0.0);
        var updatedDateRange = __assign({}, (updatedRange !== null && updatedRange !== void 0 ? updatedRange : finalDateRange));
        switch (typedValue) {
            case dateRangePicker_constants_1.DATE_FILTER_CATEGORIES.ALL_TIME:
                updatedDateRange = {
                    start: null,
                    end: null,
                };
                break;
            case dateRangePicker_constants_1.DATE_FILTER_CATEGORIES.CUSTOM_DATE_RANGE:
                break;
            case dateRangePicker_constants_1.DATE_FILTER_CATEGORIES.LAST_30_DAYS:
                updatedDateRange = {
                    start: date_fns_1.sub(today, { days: 29 }),
                    end: today,
                };
                break;
            case dateRangePicker_constants_1.DATE_FILTER_CATEGORIES.THIS_MONTH:
                updatedDateRange = {
                    start: date_fns_1.startOfMonth(today),
                    end: date_fns_1.endOfMonth(today),
                };
                break;
            case dateRangePicker_constants_1.DATE_FILTER_CATEGORIES.LAST_MONTH: {
                var lastMonth = date_fns_1.sub(today, { months: 1 });
                updatedDateRange = {
                    start: date_fns_1.startOfMonth(lastMonth),
                    end: date_fns_1.endOfMonth(lastMonth),
                };
                break;
            }
            case dateRangePicker_constants_1.DATE_FILTER_CATEGORIES.THIS_QUARTER:
                updatedDateRange = {
                    start: date_fns_1.startOfQuarter(today),
                    end: date_fns_1.endOfQuarter(today),
                };
                break;
            case dateRangePicker_constants_1.DATE_FILTER_CATEGORIES.LAST_QUARTER: {
                var dayInLastQuarter = date_fns_1.sub(today, { months: 3 });
                updatedDateRange = {
                    start: date_fns_1.startOfQuarter(dayInLastQuarter),
                    end: date_fns_1.endOfQuarter(dayInLastQuarter),
                };
                break;
            }
            case dateRangePicker_constants_1.DATE_FILTER_CATEGORIES.THIS_YEAR:
                updatedDateRange = {
                    start: date_fns_1.startOfYear(today),
                    end: date_fns_1.endOfYear(today),
                };
                break;
            case dateRangePicker_constants_1.DATE_FILTER_CATEGORIES.LAST_YEAR: {
                var lastYear = date_fns_1.sub(today, { years: 1 });
                updatedDateRange = {
                    start: date_fns_1.startOfYear(lastYear),
                    end: date_fns_1.endOfYear(lastYear),
                };
                break;
            }
        }
        setSelectedCategory(typedValue);
        setFinalDateRange(updatedDateRange);
        eventCallback === null || eventCallback === void 0 ? void 0 : eventCallback(mixpanel_events_1.mixpanelEvents.DATE_RANGE_CHANGE, {
            id: id,
            startDate: updatedDateRange.start,
            endDate: updatedDateRange.end,
            selectedCategory: typedValue,
            inputType: 'DATE_CATEGORY',
        });
        onChange(typedValue, updatedDateRange);
    };
    var handleRangeChange = function (value, updatedCategory) {
        setRange(value.selection);
        var updatedDateRange = {
            start: value.selection.startDate,
            end: value.selection.endDate,
        };
        setFinalDateRange(updatedDateRange);
        eventCallback === null || eventCallback === void 0 ? void 0 : eventCallback(mixpanel_events_1.mixpanelEvents.DATE_RANGE_CHANGE, {
            id: id,
            startDate: updatedDateRange.start,
            endDate: updatedDateRange.end,
            selectedCategory: updatedCategory !== null && updatedCategory !== void 0 ? updatedCategory : selectedCategory,
            inputType: 'DATE_RANGE',
        });
        !!updatedCategory && setSelectedCategory(updatedCategory);
        onChange(updatedCategory !== null && updatedCategory !== void 0 ? updatedCategory : selectedCategory, updatedDateRange);
    };
    var handleDateChange = function (changedDate, type) {
        var date = new Date(changedDate.toString());
        date = date instanceof Date && !isNaN(date === null || date === void 0 ? void 0 : date.getTime()) ? date : null;
        var today = new Date();
        var updatedDateRange = finalDateRange ? __assign({}, finalDateRange) : { start: today, end: today };
        var newRange = __assign({}, range);
        if (type === 'start') {
            updatedDateRange.start = date;
            newRange.startDate = date;
        }
        else {
            updatedDateRange.end = date;
            newRange.endDate = date;
        }
        setFinalDateRange(updatedDateRange);
        setRange(newRange);
        eventCallback === null || eventCallback === void 0 ? void 0 : eventCallback(mixpanel_events_1.mixpanelEvents.DATE_RANGE_CHANGE, {
            id: id,
            startDate: updatedDateRange.start,
            endDate: updatedDateRange.end,
            selectedCategory: selectedCategory,
            inputType: 'INPUT',
        });
        onChange(selectedCategory, updatedDateRange);
    };
    var defaultCategoryValue = (_f = dateRangePicker_constants_1.DATE_FILTER_OPTIONS.find(function (each) { return each.value === selectedCategory; })) !== null && _f !== void 0 ? _f : dateRangePicker_constants_1.DATE_FILTER_OPTIONS[0];
    react_1.useEffect(function () {
        var _a, _b;
        setSelectedCategory(defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.category);
        setFinalDateRange({
            start: (_a = defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.start) !== null && _a !== void 0 ? _a : new Date(),
            end: (_b = defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.end) !== null && _b !== void 0 ? _b : new Date(),
        });
    }, [defaultValue]);
    return (react_1.default.createElement(react_1.default.Fragment, null, useV2 ? (react_1.default.createElement(DateRangeComponentV2_1.DateRangeComponentV2, { className: className, eventCallback: eventCallback, onCategorySelect: handleCategorySelect, defaultCategoryValue: defaultCategoryValue, selectedCategory: selectedCategory, finalDateRange: finalDateRange, onDateChange: handleDateChange, range: range, onRangeChange: handleRangeChange, menuWrapperClassName: menuWrapperClassName, id: id, controlClassName: controlClassName, disabled: disabled, customRangeOptions: customRangeOptions, leadingIconClassname: leadingIconClassname })) : useMenuOnly ? (react_1.default.createElement(DateRangeMenu_1.default, { eventCallback: eventCallback, onDateChange: handleDateChange, range: range, onRangeChange: handleRangeChange, onCategorySelect: handleCategorySelect, disabled: disabled, defaultCategoryValue: defaultCategoryValue, id: id })) : (react_1.default.createElement(DateRangeComponent_1.DateRangeComponent, { className: className, eventCallback: eventCallback, onCategorySelect: handleCategorySelect, defaultCategoryValue: defaultCategoryValue, selectedCategory: selectedCategory, finalDateRange: finalDateRange, onDateChange: handleDateChange, range: range, onRangeChange: handleRangeChange, id: id }))));
};
exports.DateRange = DateRange;
